import React, { useState } from 'react';
import { CloseGreyIcon } from '../../../assets/icons';
import { localService } from '../../../services/localService';
import { useNotification } from '../../toster-notification/NotificationContext';
import Loader from '../../shared/Loader';

interface AddLocalFromJsonViewProps {
    onClose: () => void;
}

const AddLocalFromJsonView: React.FC<AddLocalFromJsonViewProps> = ({ onClose }) => {

    const [json, setJson] = useState<string>();

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


const handleCreateLocal = async () => {
    if (!json || json.trim() === "") {
        notify("error", "Please provide JSON data.");
        return;
    }

    let parsedLocal: unknown;

    try {
        parsedLocal = JSON.parse(json);
    } catch {
        notify("error", "JSON format is invalid.");
        return;
    }

    setLoading(true);

    try {
        const response =
            await localService.createFromJson(parsedLocal);

        notify(
            "success",
            response.message ||
                "Local created successfully."
        );

        onClose();
    } catch (error: any) {
        notify(
            "error",
            error.response?.data?.message ||
                error.response?.data?.title ||
                "Failed to create local."
        );

        console.error(error);
    } finally {
        setLoading(false);
    }
};

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Add New Local</div>
                                <div className="description-text">Enter details for the new local</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Unesi Json</label>
                                    <textarea placeholder="" className="form-textarea grey w-input"
                                        value={json}
                                        onChange={(e) => setJson(e.target.value)}
                                    ></textarea>
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Cancel</div>
                            </div>
                            <div className="button-primary medium" onClick={handleCreateLocal}>
                                <div>Add Local</div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </section >
    );
};

export default AddLocalFromJsonView;